import { Button, Caption, Title } from '@telegram-apps/telegram-ui';

import { useT } from '../hooks/useT.js';
import styles from './RotateConfirmSheet.module.css';

/**
 * RotateConfirmSheet — нижняя шторка подтверждения ПЕРЕД сменой кода (work-033).
 *
 * Смена кода необратима и рвёт петлю: старый код мгновенно гасится (retired →
 * resolveActiveCode вернёт null), и любой, кто набрал его из уже опубликованной
 * сторис, получает «коробка не найдена». На проде 2026-07-04 замер показал
 * всплеск смен (18 из 19 за сутки, один автор сменил код 7×) — это самопорча
 * воронки, а не бегство от спама. Гейт-подтверждение отсекает случайные тапы,
 * сохраняя аварийный выход тем, кому он правда нужен.
 *
 * «Глупый» презентационный компонент по образцу AgeGateSheet: БЕЗ хуков
 * состояния и MainButton — только разметка/стили шторки + два действия через
 * пропы. Открытие — user-gesture у MyCodePanel. Кнопка подтверждения
 * `mode="filled"` (акцент): деструктивного стиля у кита нет, а красный текст
 * на primary-кнопке нечитаем — акцент + чёткий текст предупреждения выше.
 */
export interface RotateConfirmSheetProps {
  /** Показывать ли шторку. Не рисуется, если false. */
  open: boolean;
  /** Подтверждение смены (user-gesture) → погасить старый, выдать новый. */
  onConfirm: () => void;
  /** Отмена — закрыть шторку без смены. */
  onCancel: () => void;
}

export function RotateConfirmSheet({ open, onConfirm, onCancel }: RotateConfirmSheetProps) {
  const t = useT();
  if (!open) return null;
  return (
    <div role="dialog" aria-modal="true" className={styles.backdrop}>
      <div className={styles.sheet}>
        <Title level="3" weight="2" className={styles.title}>
          {t.settings_my_code_rotate_confirm_title}
        </Title>
        <Caption level="1" className={styles.desc}>
          {t.settings_my_code_rotate_confirm_desc}
        </Caption>
        <div className={styles.btns}>
          <Button size="l" stretched onClick={onConfirm}>
            {t.settings_my_code_rotate_confirm_action}
          </Button>
          <Button size="l" mode="plain" stretched onClick={onCancel}>
            {t.cancel}
          </Button>
        </div>
      </div>
    </div>
  );
}
